import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.lpu.closed &&
    _setup.lpuAddress &&
    (_setup.lpuAddress.schedule_status || _setup.lpuAddress.schedule_str)
    ? _c(
        "div",
        { staticClass: "work-schedule" },
        [
          !_setup.isMobile
            ? _c(
                VMenu,
                {
                  staticClass: "work-schedule__menu",
                  attrs: {
                    attach: "",
                    "content-class": "work-schedule__menu-content",
                    "min-width": "301",
                    "max-width": "301",
                    "nudge-bottom": "12",
                    "z-index": "110",
                    "allow-overflow": false,
                    "close-on-content-click": false,
                    "open-on-hover": "",
                    "open-on-click": false,
                    "open-on-focus": false,
                    "offset-y": "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ attrs, on }) {
                          return [
                            _c(
                              _setup.InfoCard,
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "cursor-pointer h-100",
                                    attrs: {
                                      "data-qa": "lpu_work_schedule",
                                      icon: "ui-icon-filled-clock",
                                      title: `${_setup.tStatic(
                                        "Режим работы"
                                      )}:`,
                                      "use-hover": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _setup.lpuAddress.schedule_status
                                          ? {
                                              key: "subtitle",
                                              fn: function () {
                                                return [
                                                  _vm._v(
                                                    "\n          " +
                                                      _vm._s(
                                                        _setup.tDynamic(
                                                          _setup.lpuAddress,
                                                          "schedule_status"
                                                        )
                                                      ) +
                                                      "\n        "
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : {
                                              key: "subtitle",
                                              fn: function () {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _setup
                                                          .tDynamic(
                                                            _setup.lpuAddress,
                                                            "schedule_str"
                                                          )
                                                          .toUpperCase() /* eslint-disable-line vue/no-v-html */
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  "InfoCard",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1857569383
                  ),
                  model: {
                    value: _setup.isOpen,
                    callback: function ($$v) {
                      _setup.isOpen = $$v
                    },
                    expression: "isOpen",
                  },
                },
                [
                  _vm._v(" "),
                  _c(_setup.WorkSchedulePanel, {
                    attrs: {
                      schedule: _setup.schedule,
                      "is-loading": _setup.isLoading,
                    },
                  }),
                ],
                1
              )
            : [
                _c(_setup.InfoCard, {
                  staticClass: "cursor-pointer",
                  attrs: {
                    "data-qa": "lpu_work_schedule",
                    icon: "ui-icon-filled-clock",
                    title: `${_setup.tStatic("Режим работы")}:`,
                  },
                  on: {
                    click: function ($event) {
                      _setup.isOpen = true
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      _setup.lpuAddress.schedule_status
                        ? {
                            key: "subtitle",
                            fn: function () {
                              return [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _setup.tDynamic(
                                        _setup.lpuAddress,
                                        "schedule_status"
                                      )
                                    ) +
                                    "\n      "
                                ),
                              ]
                            },
                            proxy: true,
                          }
                        : {
                            key: "subtitle",
                            fn: function () {
                              return [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _setup
                                        .tDynamic(
                                          _setup.lpuAddress,
                                          "schedule_str"
                                        )
                                        .toUpperCase() /* eslint-disable-line vue/no-v-html */
                                    ),
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _c(
                  VBottomSheet,
                  {
                    model: {
                      value: _setup.isOpen,
                      callback: function ($$v) {
                        _setup.isOpen = $$v
                      },
                      expression: "isOpen",
                    },
                  },
                  [
                    _c(
                      VSheet,
                      { staticClass: "pa-4" },
                      [
                        _c(
                          "div",
                          { staticClass: "mb-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "text-h6 text--text mb-4" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_setup.tStatic("График работы")) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(_setup.WorkSchedulePanel, {
                              attrs: {
                                schedule: _setup.schedule,
                                "is-loading": _setup.isLoading,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          VBtn,
                          {
                            staticClass: "branding-btn branding-btn--primary",
                            attrs: {
                              block: "",
                              depressed: "",
                              color: "primary",
                              "data-qa": "lpu_work_schedule_close",
                            },
                            on: {
                              click: function ($event) {
                                _setup.isOpen = false
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_setup.tStatic("Понятно")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }